import { PartialTranslation } from '../translations';

export const tg: PartialTranslation = {
  newChat: 'Гуфтугӯи нав',
  search: 'Ҷустуҷӯ',
  user: 'Корбар',
  settings: 'Танзимот',
  language: 'Забон',
  getHelp: 'Кӯмак гиред',
  viewAllPlans: 'Ҳамаи нақшаҳоро дидан',
  learnMore: 'Бештар омӯзед',
  logOut: 'Хуруҷ',
  chooseLanguage: 'Забон интихоб кунед',
  chooseYourPreferredLanguage: 'Забони дӯстдоштаи худро интихоб кунед',
  searchLanguages: 'Забонҳоро ҷустуҷӯ кунед...',
  autoDetect: 'Ошкоркунии худкор',
  noLanguagesFound: 'Забонҳо ёфт нашуданд',
  askAnything: 'Ҳар чизеро пурсед',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Шахсӣ',
  freePlan: 'Нақшаи ройгон',
  current: 'Ҷорӣ',
  close: 'Пӯшидан',
  archive: 'Бойгонӣ',
  delete: 'Нест кардан',
  confirmDelete: 'Мутмаинед, ки мехоҳед ин гуфтугӯро нест кунед?',
  confirmArchive: 'Мутмаинед, ки мехоҳед ин гуфтугӯро ба бойгонӣ гузоред?',
  deleteCannotUndo: 'Ин амалро баргардонида наметавон.',
  archiveCanFind: 'Пас аз бойгонӣ кардан онро дар рӯйхати бойгонӣ ёфта метавонед.',
  resources: 'Захираҳо',
  addResource: 'Захира илова кунед',
  deleteResource: 'Захираро нест кунед',
  noMatchingResourcesFound: 'Захираҳои мувофиқ ёфт нашуданд',
  noResourcesAvailable: 'Захираҳои дастрас нестанд',
  hideResources: 'Захираҳоро пинҳон кунед',
  showResources: 'Захираҳоро нишон диҳед',
  typeMessage: 'Паём навишед...',
  thinkingOptions: 'Имконоти фикрронӣ',
  deleteFile: 'Файлро нест кунед',
  clearSelection: 'Интихобро тоза кунед',
  addAttachment: 'Замимаи илова кунед',
  sendMessage: 'Паём фиристед',
  deepInsight: 'Фаҳмиши амиқ · Таҳлили сатҳӣ',
  deepInsightDesc: 'Фаҳмиши зуди нуктаҳои калидӣ',
  deepExploration: 'Таҳқиқоти амиқ · Таҳлили пурра',
  deepExplorationDesc: 'Таҳқиқоти амиқи бисёрҷанба',
  deepDeconstruction: 'Таҷзияи амиқ · Далели системавӣ',
  deepDeconstructionDesc: 'Таҳлили пешравии қабатӣ',
  contractReview: 'Баррасии шартнома · Муайянкунии хатар',
  contractReviewDesc: 'Таҳлили банду мувофиқатсанҷӣ',
  textPolish: 'Ҷилодиҳии матн · Ифодаи касбӣ',
  textPolishDesc: 'Беҳинасозии забон ва танзими сохтор',
  legalDocuments: 'Ҳуҷҷатҳои ҳуқуқӣ · Лоиҳаи стандартӣ',
  legalDocumentsDesc: 'Навиштани касбии ҳуҷҷатҳои ҳуқуқӣ',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Воридшавӣ',
  register: 'Бақайдгирӣ',
  welcomeBack: 'Хуш омадед ба LawHelper',
  loginSubtitle: 'Дастёри таҳқиқоти ҳуқуқии AI-и шумо',
  continueWithGoogle: 'Бо Google идома диҳед',
  continueWithMicrosoft: 'Бо Microsoft идома диҳед',
  continueWithWeChat: 'Бо WeChat идома диҳед',
  orContinueWith: 'ё идома диҳед бо',
  emailTab: 'Почтаи электронӣ',
  phoneTab: 'Телефон',
  emailPlaceholder: 'Почтаи электронии худро ворид кунед',
  phonePlaceholder: 'Рақами телефонро ворид кунед',
  codePlaceholder: 'Рамзи 6-рақамаро ворид кунед',
  sending: 'Фиристода мешавад...',
  verifying: 'Тасдиқ мешавад...',
  verify: 'Тасдиқ кунед',
  sendMagicLink: 'Истиноди ҷодуиро фиристед',
  getVerificationCode: 'Рамзро гиред',
  resendCode: 'Рамзро аз нав фиристед',
  resendIn: 'Аз нав фиристед',
  magicLinkSent: 'Истиноди ҷодуӣ ба почтаи электронии шумо фиристода шуд',
  magicLinkHint: 'Мо истиноди бехатарро ба почтаи электронии шумо мефиристем',
  otpSent: 'Рамзи тасдиқ фиристода шуд',
  agreeToTerms: 'Бо идомаи кор, шумо розӣ ҳастед бо',
  privacyPolicy: 'Сиёсати махфият',
  termsOfService: 'Шартҳои хидматрасонӣ',
  and: 'ва',
  privacyTitle: 'Махфияти шумо муҳим аст',
  privacyIntro: 'Мо кукиҳо ва технологияҳои монандро барои пешниҳоди беҳтарин таҷриба истифода мебарем.',
  essentialCookies: 'Кукиҳои зарурӣ',
  essentialDesc: 'Барои кори вебсайт зарур аст',
  analyticsCookies: 'Кукиҳои таҳлилӣ',
  analyticsDesc: 'Барои беҳтар кардани хидмат кӯмак мекунад',
  marketingCookies: 'Кукиҳои маркетингӣ',
  marketingDesc: 'Барои мундариҷаи шахсӣ истифода мешавад',
  acceptAll: 'Ҳамаро қабул кунед',
  essentialOnly: 'Танҳо зарурӣ',
  customize: 'Танзим кунед',
  savePreferences: 'Танзимотро нигоҳ доред',
  back: 'Бозгашт',
  readPrivacyPolicy: 'Сиёсати махфияти моро бихонед',
  cookiePolicy: 'Сиёсати кукӣ',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Тафтиш AI',
  aiDraft: 'Пешнавис AI',
  smartAssistant: 'Намуна',

  // 知识库搜索
  enableKnowledgeSearch: 'Фаъол кардани ҷустуҷӯ',
  knowledgeSearchDesc: 'AI дар ҳуҷҷатҳои шумо меҷӯяд',
  clickToDisable: 'Хомӯш',
  clickToEnable: 'Фаъол',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Жавоби зуд',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Бекор кардан',
  library: 'Китобхона',
  filterAll: 'Ҳама',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Фикр мекунад...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'Умумӣ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'Дар бораи',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Дастяри ҳужжатҳои зирак',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Хато',
  unknownError: 'Unknown error',
  file: 'Файл',
  loading: 'Боркунӣ...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'Таҳлили AI',
};
